export const LOCAL_CONSTANT = {

  /**
   * 書類名
   * @type {string}
   */
  DOCUMENT_NAME: '自動納付申出書／取下書',

  /**
   * 説明
   * @type {string}
   */
  DISCRIPTION: '特殊申請の書類PDFの作成を支援するツールです。',

  /**
   * バージョン
   * @type {string}
   */
  VERSION: '1.1.0版',

  /**
   * 差出書面に記載する登録番号の最大数（超えた場合は別紙記載とする）
   * @type {number}
   */
  MAX_REGISTRATION_NUMBER_COUNT: 10,

  /**
   * 法人格
   * @type {string[]}
   */
  LEGAL_PERSONALITIES: [
    '株式会社',
    '合同会社',
    '有限会社',
    '一般社団法人', 
    '一般財団法人',
    '法人'
  ]

};